/* eslint-disable react/prop-types */
import React from 'react';

// Generic sub-tab strip (reuses the ud-subtabs styling introduced by PauseRecordsTab).
// Each item is { key, label }. Purely presentational — the parent owns the active key,
// so a box's drill-down can be shown inline instead of navigating to a detail page.
const SubTabs = ({ items, active, onSelect, ariaLabel = 'Section' }) => (
  <div className="ud-subtabs" role="tablist" aria-label={ariaLabel}>
    {items.map((it) => (
      <button
        key={it.key}
        type="button"
        role="tab"
        aria-selected={active === it.key}
        className={`ud-subtab${active === it.key ? ' ud-subtab--on' : ''}`}
        data-testid={`ud-subtab-${it.key}`}
        onClick={() => onSelect(it.key)}
      >
        {it.label}
      </button>
    ))}
  </div>
);

export default SubTabs;
